import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a2b0380"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-9",
  class: "page-9"
}
const _hoisted_2 = { class: "d-block d-md-none step" }

import ResponsiveImage from '../responsive-image.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpg'),
      "image-webp": require('./bg.webp'),
      "mobile-image": require('./bg-m.jpg'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 1994,
      "image-w": 3840,
      "mobile-image-h": 1929,
      "mobile-image-w": 1170
    }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ResponsiveImage, {
        class: "img",
        image: require('./step.png'),
        "image-webp": require('./step.webp')
      }, null, 8, ["image", "image-webp"])
    ])
  ]))
}
}

})